import { TipoReferenciaNotificacaoType } from '../../../../../_metronic/helpers'
import { ReferenciaNotificacao } from './_models'

export type DestinoNotificacao = { tipo: 'notaVersao'; idNota: number } | { tipo: 'detalhe' }

/** Para onde o clique numa notificação leva. Referência desconhecida cai no detalhe de sempre. */
export const destinoNotificacao = ({
  tipoReferencia,
  idReferencia,
}: ReferenciaNotificacao): DestinoNotificacao => {
  if (
    tipoReferencia === TipoReferenciaNotificacaoType.NotaVersao &&
    typeof idReferencia === 'number' &&
    Number.isInteger(idReferencia) &&
    idReferencia > 0
  ) {
    return { tipo: 'notaVersao', idNota: idReferencia }
  }
  return { tipo: 'detalhe' }
}
